module.exports = require("@mui/icons-material/Schema");